module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_front_bg_pastel-66fde3a28cf4da81c6e1df92bdf5291a.png";